<template>
  <div class="tabs flex" @mouseleave="checkvalue=oldValue">
    <div
      class="tabslist flex jc ac f1 bgps"
      v-for="(i, j) in namelist"
      @mouseenter="checkvalue=j"
      @click="tabclick(j)"
      :style="{
        backgroundImage: checkvalue == j ? `url(${src})` : '',
        color: checkvalue == j ? '#fff' : '#8AA0BC',
        fontSize:checkvalue == j ? '1rem' : '.9375rem',
        fontFamily:checkvalue == j ?'AlibabaPuHuiTi_2_75_SemiBold':'AlibabaPuHuiTi_2_55_Regular',
      }"
    >
      {{ i.label }}<span>{{ i.value ? `&nbsp;${i.value}` : "" }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    namelist: {
      default: function () {
        return [{ label: "选项一", value: "" }];
      },
    },
  },
  data() {
    return {
      checkvalue: 0,
      src: require("../../assets/image/按钮效果.png"),
      oldValue:0
    };
  },
  methods: {
    tabclick(e) {
      this.$emit('tabnum',e)
      for (let i in this.namelist) {
        if (i == e) {
          this.checkvalue = e;
          this.oldValue = e
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  .tabslist {
    font-size: 0.83vw;
    background-repeat: no-repeat;
    color: #8AA0BC;
   

  }
  width: 100%;
  height: 100%;
  min-width: 2.08vw;
  min-height: 2.08vw;
  background: url("../../assets/image/滚动条.png") no-repeat;
}
</style>
